import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiService, Mk2Request, Mk2Response } from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';

export class FilterCriteria {
    buyerName?: string;
    supplierName?: string;

    constructor(initial?: Partial<FilterCriteria>) {
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

export interface RelationshipFilterInput {
    supplierName?: string;
    buyerName?: string;
}

export class ListRelationshipKeysRequest extends Mk2Request {
    filter?: FilterCriteria;

    constructor(initial?: Partial<ListRelationshipKeysRequest>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

export class ListRelationshipKeysResponse extends Mk2Response {
    relationshipKeys?: string[];

    constructor(initial?: Partial<ListRelationshipKeysResponse>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

@Injectable({ providedIn: 'root' })
export class ListRelationshipKeysService extends ApiService<
    ListRelationshipKeysRequest,
    ListRelationshipKeysResponse
> {
    public requestType = ListRelationshipKeysRequest;
    public responseType = ListRelationshipKeysResponse;
    public endpointName = 'v1/scf/listRelationshipKeys';
    public serviceName = 'supplierMgmtApi';

    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);

        this.endpointName = 'v1/scf/listRelationshipKeys';
        this.serviceName = 'supplierMgmtApi';
        this.usePascalForUrl = false;
    }

    public requestMapper(req: ListRelationshipKeysRequest): ListRelationshipKeysRequest {
        const request = new ListRelationshipKeysRequest({
            filter:
                req.filter === undefined
                    ? new FilterCriteria({ supplierName: '', buyerName: '' })
                    : req.filter
        });
        if (request.filter.supplierName === null) request.filter.supplierName = '';
        if (request.filter.buyerName === null) request.filter.buyerName = '';
        return request;
    }

    public responseMapper(
        res: string[] | ListRelationshipKeysResponse
    ): ListRelationshipKeysResponse {
        return res as ListRelationshipKeysResponse;
    }

    public get endpointUrl(): string {
        return super.endpointUrl.replace('/api', '');
    }
}
